import React from 'react';
import FormDialog from '../FormControl/FormDialog';
import { Checkbox, FormControl, FormControlLabel, FormHelperText, TextField } from '@mui/material';
import DefaultButton from '../FormControl/DefaultButton';
import ErrorButton from '../FormControl/ErrorButton';
import { FormDirty, FormErrors, FormValidationSchema } from '../FormControl/Form/Form';
import * as Yup from 'yup';
import useTranslate from '../Translate/useTranslate';

export interface ChangePasswordDialogData {
    oldPassword: string;
    newPassword: string;
    confirmNewPassword: string;
}

export interface ChangePasswordDialogState {

}

export interface ChangePasswordDialogProps {
    changePasswordDialogOpen: boolean;
    onSubmit: (data: ChangePasswordDialogData) => any;
    onCancel: () => any;
}

const validationSchema: FormValidationSchema<ChangePasswordDialogData> = {
    oldPassword: Yup.string()
        .trim()
        .required()
        .min(7)
        .max(80)
        .label("Senha"),
    newPassword: Yup.string()
        .trim()
        .required()
        .min(7)
        .max(80)
        .label("Nova Senha"),
    confirmNewPassword: Yup.string()
        .trim()
        .required()
        .min(7)
        .max(80)
        .label("Confirme a Senha")

}


function ChangePasswordDialog(props: ChangePasswordDialogProps) {

    const { onCancel, changePasswordDialogOpen } = props;

    const t = useTranslate();

    function onSubmitHandler(data: ChangePasswordDialogData, errors: FormDirty<any>) {
        const { onSubmit } = props;
        onSubmit(data);
    }

    async function validateForm(data: ChangePasswordDialogData): Promise<FormErrors<ChangePasswordDialogData>> {
        if (data.newPassword != data.confirmNewPassword) {
            return {
                confirmNewPassword: "Senhas não conferem"
            };
        }
        return {};
    }

    return (
        <FormDialog
            show={changePasswordDialogOpen}
            title={t('changePassword', { capitalize: true, namespace: 'changePassword' })}
            dismiss={() => onCancel()}
            validationSchema={validationSchema}
            onSubmit={(values, errors, dirty) => {
                const { newPassword, confirmNewPassword, oldPassword } = values;
                if (!dirty || !dirty.newPassword && !dirty.confirmNewPassword && !dirty.oldPassword) {
                    onSubmitHandler({ newPassword, confirmNewPassword, oldPassword }, errors);
                }
            }}
            initialValues={{ newPassword: '', confirmNewPassword: '', oldPassword: '' }}
            enableReinitialize={true}
            maxWidth='sm'
            fullWidth
            validate={validateForm}

        >
            {({ values, errors, handleChange, setFieldValue, isSubmitting, dirty }) => (
                <>

                    <TextField
                        type="password"
                        name="oldPassword"
                        label={t('currentPassword', { capitalize: true, namespace: 'changePassword' })}
                        margin="dense"
                        variant="outlined"
                        autoComplete="new-password"
                        required
                        fullWidth
                        autoFocus={true}
                        value={values.oldPassword}
                        onChange={(e) => handleChange(e)}
                        error={!!errors.oldPassword && !!dirty.oldPassword}
                        helperText={!!errors.oldPassword && !!dirty.oldPassword && errors.oldPassword}
                    />
                    <TextField
                        type="password"
                        name="newPassword"
                        label={t('newPassword', { capitalize: true, namespace: 'changePassword' })}
                        margin="dense"
                        variant="outlined"
                        autoComplete="new-password"
                        required
                        fullWidth
                        value={values.newPassword}
                        onChange={(e) => handleChange(e)}
                        error={!!errors.newPassword && !!dirty.newPassword}
                        helperText={!!errors.newPassword && !!dirty.newPassword && errors.newPassword}
                    />
                    <TextField
                        type="password"
                        name="confirmNewPassword"
                        label={t('confirmNewPassword', { capitalize: true, namespace: 'changePassword' })}
                        margin="dense"
                        variant="outlined"
                        autoComplete="new-password"
                        required
                        fullWidth
                        value={values.confirmNewPassword}
                        onChange={(e) => handleChange(e)}
                        error={!!errors.confirmNewPassword && !!dirty.confirmNewPassword}
                        helperText={!!errors.confirmNewPassword && !!dirty.confirmNewPassword && errors.confirmNewPassword}
                    />
                    <FormControl fullWidth variant="outlined" margin="dense" style={{ flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <ErrorButton
                            size='small'
                            variant="contained"
                            disabled={isSubmitting}
                            onClick={() => onCancel()}
                        >
                            {t('cancel', { capitalize: true, namespace: 'form' })}
                        </ErrorButton>
                        <DefaultButton
                            size='small'
                            type='submit'
                            variant="contained"
                            style={{ marginLeft: 10 }}
                            disabled={isSubmitting}>
                            OK
                        </DefaultButton>
                    </FormControl>
                </>
            )}
        </FormDialog>
    );

}

export default ChangePasswordDialog;